import { Injectable } from '@angular/core';
import {
  BaseRouteReuseStrategy,
  type ActivatedRouteSnapshot,
} from '@angular/router';
import { isEqual } from 'lodash-es';

/**
 *
 * ❗️❗️❗️ **DO NOT USE IT** ❗️❗️❗️ unless you have tried other solutions and none of them worked.
 *
 * @description
 *
 * This is workaround and should be used only as a last resort. It should be removed
 * in the future as it is temporary solution.
 *
 * How it works?
 *
 * It forces component destruction and recreation
 * when navigating between routes that opt-in via `data: { reuseOnParamChange: false }`.
 *
 * Why it was created?
 *
 * Due to component that is not reactive to param change and it was too complex to refactor
 * with reasonable time constraints.
 *
 * @see {@link SupplierPageContainerComponent}
 */
@Injectable()
export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ): boolean {
    const defaultReuse = super.shouldReuseRoute(future, current);

    if (!defaultReuse) {
      return false;
    }

    if (future.data['reuseOnParamChange'] !== false) {
      return true;
    }

    return isEqual(future.params, current.params);
  }
}
